import React from "react";
import SkinVoteItem from "./SkinVoteItem";
import { Col, Row } from "react-bootstrap";
import SkinVoteRules from "./SkinVoteRules";
import {useFetchSkins} from "../../../features/skin/skinApi";
import "./SkinVote.scss"

const SkinVoteList = () => {
    const {data:skins} = useFetchSkins();



    if (!skins) {
        return <></>
    }

    const [firstSkin, secondSkin, thirdSkin, ...restSkins] = skins;
    const topSkinIndex = 0;

    return (
        <>
        <SkinVoteRules/>
            <Row className={'align-items-end top-skins mb-5'}>
                <Col md={4}>
                    <SkinVoteItem
                        key={firstSkin.id}
                        skin={firstSkin}
                        size="lg"
                        isTopSkin={true}
                    />
                </Col>
                <Col md={4}>
                    <SkinVoteItem
                        key={secondSkin.id}
                        skin={secondSkin}
                        size="md"
                        isTopSkin={true}
                    />
                </Col>
                <Col md={4}>
                    <SkinVoteItem
                        key={thirdSkin.id}
                        skin={thirdSkin}
                        size="sm"
                        isTopSkin={true}
                    />
                </Col>
            </Row>
            <hr/>
            <Row md={6}>
                {restSkins.map((skin, index) => (
                    <Col
                        md={index < 2 ? 3 : 3}
                        className={`mt-3 my-5`}
                    >
                        <SkinVoteItem
                            key={skin.id}
                            skin={skin}
                            size="md"
                            isTopSkin={index === topSkinIndex}
                        />
                    </Col>
                ))}
            </Row>
        </>
    );
};

export default SkinVoteList;
